'use es6';

const PRIVATE_APP_TOKEN_REGEX = new RegExp('pat-(na1|eu1)-[a-f0-9]{8}-(?:[a-f0-9]{4}-){3}[a-f0-9]{12}', 'g');
export const preventAccessTokenCopyListener = e => {
  const selectionText = window.getSelection().toString();
  if (PRIVATE_APP_TOKEN_REGEX.test(selectionText)) {
    e.clipboardData.setData('text/plain', selectionText.replace(PRIVATE_APP_TOKEN_REGEX, 'YOUR_ACCESS_TOKEN'));
    e.preventDefault();
  }
};